<script>
import BoxCard from './BoxCard'
import InlineCard from './InlineCard'
import InlineBrandedCard from './InlineBrandedCard'

export default {
  page: {
    title: 'Marketplace',
  },

  components: {
    BoxCard,
    InlineCard,
    InlineBrandedCard,
  },

  props: {
    list: {
      type: Object,
      default: () => {
        return {}
      },
    },
    keyword: {
      type: String,
      default: '',
    },
  },

  computed: {
    productList() {
      return this.list
    },
    menuList() {
      return this.$store.state.marketplace.sideMenu
    },
  },
}
</script>

<template>
  <div>
    <div v-for="menu in menuList" :key="menu.section" class="my-3">
      <template v-if="menu.section !== 'all'">
        <BoxCard
          v-if="menu.display === 'box'"
          class="mc-marketplace-card"
          :list="productList[menu.section]"
          :title="menu.section"
        />
        <InlineCard
          v-if="menu.display === 'inline'"
          class="mc-marketplace-inline"
          :list="productList[menu.section]"
          :title="menu.section"
          :keyword="keyword"
        />
        <InlineBrandedCard
          v-if="menu.display === 'inline-branded'"
          class="mc-marketplace-inline"
          :list="productList[menu.section]"
          :title="menu.section"
          :keyword="keyword"
        />
        <div v-if="!productList[menu.section]">
          <b-card>
            <b-row class="mt-4">
              <h5 class="text-center">
                {{ $t('global.text.noData') }}
              </h5>
            </b-row>
          </b-card>
        </div>
      </template>
    </div>
  </div>
</template>
